// extracted by mini-css-extract-plugin
export default {"languages-block":"language_languages-block__-IXXb","languages-dropdown":"language_languages-dropdown__yEHlI"};